import { getAllCustomers } from '@/redux/actions/customerActions';
import { getSitesByCustomerID } from '@/redux/actions/siteActions';
import { SelectField } from '@/shared/components/form/CompanyDropdownSelect';
import { colorText } from '@/utils/palette';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { getUserProvisioning } from '@/redux/actions/alertingToolsActions';
import { getCurrentCompanyToken } from '@/redux/actions/authActions';
import { getCurrentCustomer } from '@/redux/actions/customerActions';
import { setCurrentSite } from '@/redux/reducers/sitesReducers';
import useUrlQueryParams from '@/utils/hooks/useUrlQueryParams';
import { getLocalStorageData, setLocalStorageData } from '@/utils/LocalStorage';
import { saveToSessionStorage } from '@/utils/SessionStorage';
const SuperAdminDropdown = () => {
	const url = window.location.href;
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { encryptQueryParams } = useUrlQueryParams();

	useEffect(() => {
		dispatch(getAllCustomers());
	}, []);

	const [customers, setCustomers] = useState([]);

	const allCustomers = useSelector(state => state?.customer?.allCustomers);
	const currentCustomerID = useSelector(
		state => state?.customer?.currentCustomer?.customerID,
	);

	useEffect(() => {
		if (allCustomers?.length > 0) {
			setCustomers(allCustomers);
		}
	}, [allCustomers]);

	const customerOptions = useMemo(() => {
		return customers?.map(customer => ({
			key: customer.customerID,
			value: customer.customerID,
			label: customer.customerName,
		}));
	}, [customers]);

	useEffect(() => {
		dispatch(getCurrentCustomer());
	}, []);

	const handleChange = async selectedOption => {
		const customer = allCustomers.find(
			c => c.customerID === selectedOption?.key,
		);
		console.log('selectedOption', selectedOption);
		await dispatch(getSitesByCustomerID(selectedOption?.key)).then(data => {
			if (data?.payload?.length > 0) {
				dispatch(
					setCurrentSite({ value: 'all', label: 'All Sites', key: 'all' }),
				);
				// if (getLocalStorageData('tabsOpen') == 1) {
				setLocalStorageData('currentSiteID', 'all');
				// } else {
				saveToSessionStorage('currentSiteID', 'all');
				// }
			} else {
				dispatch(
					setCurrentSite({
						value: data?.payload[0]?.siteID,
						label: data?.payload[0]?.siteName,
						key: data?.payload[0]?.siteID,
					}),
				);
				setLocalStorageData('currentSiteID', data?.payload[0]?.siteID);
				saveToSessionStorage('currentSiteID', data?.payload[0]?.siteID);
			}

			const encryptedParams = encryptQueryParams({
				customerID: selectedOption?.key,
			});

			if (customer && url.includes('/company')) {
				dispatch(getCurrentCustomer(selectedOption?.key));
				if (getLocalStorageData('tabsOpen') == 1) {
					setLocalStorageData('currentCustomerID', selectedOption?.key);
				} else {
					saveToSessionStorage('currentCustomerID', selectedOption?.key);
				}
				navigate(`/company/${selectedOption.label}?${encryptedParams}`);
			}
			if (customer && url.includes('/companymanagement/')) {
				dispatch(getCurrentCustomer(selectedOption?.key));
				if (getLocalStorageData('tabsOpen') == 1) {
					setLocalStorageData('currentCustomerID', selectedOption?.key);
				} else {
					saveToSessionStorage('currentCustomerID', selectedOption?.key);
				}
				navigate(`/company/${selectedOption?.label}?${encryptedParams}`);
			}

			if (customer && !url.includes('/companymanagement')) {
				dispatch(getCurrentCustomer(selectedOption?.key));
				if (getLocalStorageData('tabsOpen') == 1) {
					setLocalStorageData('currentCustomerID', selectedOption?.key);
				} else {
					saveToSessionStorage('currentCustomerID', selectedOption?.key);
				}
			}

			const getToken = JSON.parse(getLocalStorageData('token'));
			let token = getToken?.currentUser?.token;
			let refresh = getToken?.currentUser?.refresh;
			dispatch(
				getCurrentCompanyToken(token.token, refresh, selectedOption?.key),
			);
			dispatch(getUserProvisioning(selectedOption?.key));
		});
	};

	return (
		<>
			<CurrentCustomer>Current Company:</CurrentCustomer>
			<DropdownContainer>
				<SelectField
					value={customerOptions.find(c => c.key === currentCustomerID)}
					name="customerName"
					options={customerOptions}
					onChange={handleChange}
				/>
			</DropdownContainer>
		</>
	);
};

export default SuperAdminDropdown;

const CurrentCustomer = styled.div`
	color: ${colorText};
	display: flex;
	height: 100%;
	flex-direction: column;
	justify-content: center;
	width: auto;
	margin-right: 10px;

	@media (max-width: 1000px) {
		display: none;
	}
`;

const DropdownContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	width: auto;
	height: 100%;
	margin-right: 20px;

	@media (max-width: 645px) {
		height: 60px;
		margin-right: 0px;
	}
`;
